module.exports = __webpack_public_path__ + "media/images/expert__inka-grings-2343396631eb1b453fccd21665ea9683.png";